import React from "react";
import FileCopy from "@material-ui/icons/FileCopy";
import { Button } from "@material-ui/core";
import styles from "./CopyToClipboard.module.scss";
import { withStyles } from "@material-ui/core/styles";
import { logMsg } from "../../common/Logger";

const CopyToClipboard = (props) => {
  const StyledButton = withStyles({
    root: {
      minWidth: 0,
    },
  })(Button);
  const StyledSaveAltIcon = withStyles({
    root: {
      height: 18,
      margin: 2,
      width: 18,
      padding: 0,
    },
  })(FileCopy);

  const copyToClipboard = (linkURL) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(linkURL).then(
        () => {
          // Copying done successfully.
        },
        (err) => {
          logMsg(err);
        }
      );
    } else {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = linkURL;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
        // Copying done successfully.
      } catch (err) {
        logMsg(err);
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <StyledButton onClick={() => copyToClipboard(props.link)}>
      <div className={styles.copyToClipboard}>
        <div>{props.text}</div>
        <StyledSaveAltIcon />
      </div>
    </StyledButton>
  );
};

export default CopyToClipboard;
